import { PXData } from 'src/app/models/PXData';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Component, OnInit, ViewChild } from '@angular/core';

import { getUserRole } from 'src/app/helpers/getUserRole';

import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-list-prep-prospects',
  templateUrl: './list-prep-prospects.component.html',
  styleUrls: ['./list-prep-prospects.component.scss']
})
export class ListPrepProspectComponent implements OnInit {

  @ViewChild('deleteModal', { static: true }) deleteModal: ModalDirective;

  rows = [];
  deleteId = '';
  private gridApi;
  private gridColumnApi;
  isLoading = false;
  defaultColDef = { resizable: true };
  isEU = getUserRole() === '4' ? true : false;
  isRSA = getUserRole() === '1' ? true : false;
  noRowsTemplate = `"<span">no rows to show</span>"`;
  viewType = localStorage.getItem('LIST_CONTACTS_VIEW_TYPE');
  listContactsName = localStorage.getItem('LIST_CONTACTS_NAME');
  listContactsCompany = localStorage.getItem('LIST_CONTACTS_COMPANY');
  listContactsListName = localStorage.getItem('LIST_CONTACTS_LISTNAME');
  loadingTemplate = `<span class="ag-overlay-loading-center">data is loading...</span>`;

  columnDefs = [
    {
      sortable: true,
      width: 100,
      resizable: true,
      field: 'companyName',
      headerName: 'Company Name',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
      cellRenderer: function (params) {
        return `<a href="${params.data.companyProfileURL}" target="_blank">${params.data.companyName}</a>`;
      }
    },

    {
      sortable: true,
      width: 100,
      field: 'fullName',
      headerName: 'Full Name',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
      valueGetter: function (params) {
        return `${params.data.firstName} ${params.data.lastName}`;
      },
      cellRenderer: function (params) {
        return `<a href="${params.data.profileURL}" title="View Profile" target="_blank">${params.value}</a>`;
      }
    },
    {
      field: 'title',
      sortable: true,
      width: 100,
      headerName: 'Title',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
    },

    {
      sortable: true,
      width: 70,
      field: 'location',
      headerName: 'Prospect Location',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      }
    },
    {
      sortable: true,
      width: 60,
      field: 'industry',
      headerName: 'Industry',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      }
    }, 
    {
      sortable: true,
      width: 100,
      field: 'organization_location_1',
      headerName: 'Company HQ',
      headerTooltip: 'Company Headquarters',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
    },
    // {
    //   sortable: true,
    //   width: 70,
    //   field: 'organization_headcount_1',
    //   headerTooltip: 'HC',
    //   filter: "agTextColumnFilter",
    //   filterParams: {
    //     buttons: ['reset', 'apply'],
    //     closeOnApply: true
    //   },
    //   valueFormatter: (params) => {
    //     return (params.value||"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //   }
    // },
    {
      field: 'organization_headcount_1',
      width: 70,
      maxWidth: 70,
      sortable: true,
      headerName: 'HC',
      headerTooltip: 'Organization Headcount',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
      cellRenderer: function(params) {
        if (params.value || params.value === 0) {
          return Number(params.value).toLocaleString();
        } else {
          return '';
        }
      },
      cellStyle: { 
        textAlign: 'right', 
        paddingRight: '10px'  // Add padding to the right
      }
    },
    // {
    //   field: 'followers',
    //   headerTooltip: 'Connections',
    //   sortable: true,
    //   width: 70,
    //   headerName: 'Conn.',
    //   filter: "agTextColumnFilter",
    //   filterParams: {
    //     buttons: ['reset', 'apply'],
    //     closeOnApply: true
    //   },
    //   valueFormatter: (params) => {
    //     return params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //   }
    // },
    {
      field: 'followers',
      width: 70,
      maxWidth: 70,
      sortable: true,
      headerTooltip: 'Connections',
      headerName: 'Conn.',
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true
      },
      valueFormatter: (params) => {
        return params.value ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      },
      cellStyle: { 
        textAlign: 'right', 
        paddingRight: '10px'  // Add padding to the right
      }
    },

    {
      colId: 'delete',
      width: 50,
      field: '',
      headerName: 'Delete',
      cellRenderer: this.trashIconRender.bind(this),
    }
  ];

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.loadData();

    if (!this.isRSA) {
      this.columnDefs = this.columnDefs.filter(col => col.colId !== 'delete'); // Remove the delete column if the user is not RSA
    }
  }

  loadData() {
    this.userService.getAVDataByListId(localStorage.getItem('LIST_CONTACTS_KEY'), localStorage.getItem('USER_KEY')).subscribe((res) => {
      const sortedRes = res.sort((a, b) => {
        if (a.companyName < b.companyName) {
          return -1;
        }
        if (a.companyName > b.companyName) {
          return 1;
        }

        if (a.firstName < b.firstName) {
          return -1;
        }
        if (a.firstName > b.firstName) {
          return 1;
        }
        return 0;
      });
      console.log(sortedRes)
      this.rows = sortedRes.filter((item: PXData) => item.approved.includes(this.viewType));
      console.log(this.rows, this.viewType)
      if (this.rows.length === 0) {
        this.gridApi.showNoRowsOverlay();
      }

    }, (err) => {
      alert('error');
      this.gridApi.showNoRowsOverlay();
      console.log('error to get user av data: ', err);
    });
  }

  // autoSizeAll() {
  //   var allColumnIds = [];

  //   this.gridColumnApi.getAllColumns().forEach(function (column) {
  //     allColumnIds.push(column.colId);
  //   });

  //   this.gridColumnApi.autoSizeColumns(allColumnIds);
  //   // this.gridApi.sizeColumnsToFit();
  // }


  // onGridReady(params) {
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;
  //   // this.gridApi.sizeColumnsToFit();
  //   this.gridApi.showLoadingOverlay();
  // }

  autoSizeAll() {
    var allColumnIds = [];

    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });

    this.gridColumnApi.autoSizeColumns(allColumnIds);
    this.gridApi.sizeColumnsToFit();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
  }


  trashIconRender(params) {
    const eDiv = document.createElement('span');
    eDiv.style.cursor = 'pointer';
    eDiv.innerHTML = `<i class="fa fa-trash-o"></i>`;

    eDiv.addEventListener('click', () => {
      this.openDeleteModal(params.data.id)
    });

    return eDiv;
  }

  openDeleteModal(deleteId) {
    this.deleteId = deleteId;
    this.deleteModal.show();
  }

  deleteRecord() {
    this.isLoading = true;

    this.userService.deleteRecord(this.deleteId).subscribe((res: any) => {
      if (res) {
        localStorage.removeItem('LIST_AVDATA_CACHED_AT');
        this.loadData();
      };

      this.isLoading = false;
      this.deleteModal.hide();

    }, (err) => {
      this.isLoading = false;
      this.deleteModal.hide();
      alert('error');
      console.log('error to delete list: ', err)
    });
  }

  exportData() {
    const con = [];

    let csvContent = 'data:text/csv;charset=utf-8,';

    Object.keys(this.rows).forEach((data) => {
      const val = this.rows[data];
      con.push(val);
    });

    const title = `Status, Rejection Reason, Company Name, First Name, Last Name, Title, Profile Url, Email, Phone, Location, Company Start Date, Tenure, Connected On, Industry, Mutual Connections`;
    csvContent += title + '\r\n';

    con.forEach(function (rowArray) {
      const row = '"' + rowArray.approved + '","' + (rowArray.rejectionReason || "N/A") + '","' + rowArray.companyName + '","' + rowArray.firstName + '","'
        + rowArray.lastName + '","' + rowArray.title + '","'
        + rowArray.profileURL + '","' + rowArray.email + '","'
        + rowArray.phone + '","' + rowArray.location + '","'
        + rowArray.yearsAtCompany + '","' + rowArray.since1 + '","' + rowArray.connectedOn
        + '","' + rowArray.industry + '","' + rowArray.mutualConnections + '"';
      csvContent += row + '\r\n';
    });

    csvContent = csvContent.replace(/#/g, '');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);

    const d = new Date();
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    const _d = `${mo}-${da}-${ye}`;

    if (this.viewType === 'Y') {
      link.setAttribute('download', `${this.listContactsCompany} - ${this.listContactsName} (${this.listContactsListName}) - Approved - Exported on ${_d}.csv`);
    } else if (this.viewType === 'N') {
      link.setAttribute('download', `${this.listContactsCompany} - ${this.listContactsName} (${this.listContactsListName}) - Rejected - Exported on ${_d}.csv`);
    } else {
      link.setAttribute('download', `${this.listContactsCompany} - ${this.listContactsName} (${this.listContactsListName}) - Exported on ${_d}.csv`);
    }

    document.body.appendChild(link); // Required for FF
    link.click();
    this.isLoading = false;
  }

}

